export const PRODUCT_DETAIL_SNACKBAR_BOTTOM_OFFSET = 90 - 20 + 12; // 구매하기 버튼으로부터 12px (CTA 영역 - 상단 패딩 + 12px)
export const OFFICIAL_BADGE_URL = 'https://static.bunjang.co.kr/shoptype_badges/ic_officialshop_badge_2025.webp';
